import AboutUsView from "./AboutUsView";

export default AboutUsView;
